import {Customer} from '@/entity/Customer';
import {Base} from '@/dto/Base';
import {Page, Pagination, RemoveEmptyUtils} from 'pansx-utils';
import {FindAllByNameContainingAndCreatorId} from "@/entity/FindAllByNameContainingAndCreatorId";

export class CustomerDto {
    public static url = '/customer';

    public static async findById(id: number): Promise<Customer> {
        const response = await Base.getDataWithJwt(this.url + '/byId', {id});
        const customer = response as Customer;
        return Customer.of(customer);
    }


    public static  async  findByName(collectName: string): Promise<Customer>{
            const  response = await  Base.getDataWithJwt(this.url + '/byName',{collectName});
            const  customer = response as  Customer;
            return  Customer.of(customer);
    }

    public static async findAll(customer: Customer): Promise<Customer[]> {
        RemoveEmptyUtils.removeEmptyString(customer);
        RemoveEmptyUtils.removeZero(customer);
        const response = await Base.getDataWithJwt<Customer[]>(
            this.url + '/all',
            customer,
        );
        const customerList = response as Customer[];
        return customerList;
    }

    public static async allPage(
        customer: Customer,
        pagination: Pagination,
    ): Promise<Page<Customer>> {
        RemoveEmptyUtils.removeEmptyString(customer);
        RemoveEmptyUtils.removeZero(customer);
        const response = await Base.findAllPageWithToken(
            this.url + '/allPage',
            pagination,
            customer,
        );
        return response as Page<Customer>;
    }

    public static async delete(id: number) {
        await Base.getDataWithJwt(this.url + '/delete', {id});
    }

    public static async save(customer: Customer): Promise<Customer> {
        const response = await Base.postWithToken(this.url + '/save', customer);
        return response as Customer;
    }

    public static async review(customer: Customer): Promise<Customer> {
        const response = await Base.postWithToken(this.url + '/review', customer);
        return response as Customer;
    }



    public static async findByRegisteredCapital(operator: ">"|"="|"<",number: number){
        const response = await Base.getDataWithJwt(this.url + '/findByRegisteredCapital', {number,operator});
        return response as Customer[];
    }

    public static async FindAllByNameContainingAndCreatorId(f: FindAllByNameContainingAndCreatorId): Promise<Customer[]> {
        const response = await Base.postWithToken<Customer[]>(this.url + '/findAllByNameContainingAndCreatorId', f,);
        const customerList = response as Customer[];
        return customerList;
    }
}
